import { useLang } from "../Contexts/LanguageContext";
function useDirection() {
  var lang = useLang();
  return lang === 'ar' ? 'rtl' : 'ltr';
}
export default useDirection;